export default __webpack_public_path__ + "static/bg-ea16f65f1247cdac0b23c9342dbaf13d.png";